import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Search, LayoutGrid, List, Settings } from 'lucide-react';

export const ProposalsToolbar = ({
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  viewMode,
  setViewMode,
  isAdmin,
  onOpenCategorySettings,
  children
}) => (
  <div className="flex gap-2 items-center">
    <div className="relative w-64">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <Input
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search by name, company, contact..."
        className="pl-9"
        data-testid="proposal-search"
      />
    </div>
    <Select value={statusFilter} onValueChange={setStatusFilter}>
      <SelectTrigger className="w-44" data-testid="proposal-status-filter">
        <SelectValue placeholder="All Statuses" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Statuses</SelectItem>
        <SelectItem value="draft">Draft</SelectItem>
        <SelectItem value="for_review">For Review</SelectItem>
        <SelectItem value="sent_to_client">Sent to Client</SelectItem>
        <SelectItem value="signed">Signed</SelectItem>
        <SelectItem value="rejected">Rejected</SelectItem>
      </SelectContent>
    </Select>
    <div className="flex border rounded-md">
      <Button
        variant={viewMode === 'tile' ? 'default' : 'ghost'}
        size="sm"
        className="rounded-r-none"
        onClick={() => setViewMode('tile')}
      >
        <LayoutGrid className="h-4 w-4" />
      </Button>
      <Button
        variant={viewMode === 'list' ? 'default' : 'ghost'}
        size="sm"
        className="rounded-l-none"
        onClick={() => setViewMode('list')}
      >
        <List className="h-4 w-4" />
      </Button>
    </div>
    {isAdmin && (
      <Button variant="outline" onClick={onOpenCategorySettings}>
        <Settings className="mr-2 h-4 w-4" />
        Categories
      </Button>
    )}
    {children}
  </div>
);
